import React, { useEffect, useCallback, useRef, Fragment } from "react"

import {
  ProductShoppableGrid,
  Carousel,
  Scroll,
  ArrowLeft,
  ArrowRight,
  Headline,
  ScrollableGrid,
  DesktopWrapper,
  MobileWrapper,
} from "./styles"
import Card from "./card"

const MultiProductShoppable = ({ elRef, component }) => {
  const { items } = component
  const [isAtStart, setIsAtStart] = React.useState(true)
  const [isAtEnd, setIsAtEnd] = React.useState(false)
  const [allItemsVisible, setAllItemsVisible] = React.useState(false)
  const [showArrowRight, setShowArrowRight] = React.useState(false)

  const carouselRef = useRef(null)

  const arrowVisibility = useCallback(() => {
    if (carouselRef.current) {
      const allVisible = carouselRef.current.scrollWidth <= carouselRef.current.offsetWidth

      if (items.length <= 3 && allVisible) {
        setShowArrowRight(false)
      } else {
        setShowArrowRight(true)
      }
    }
  }, [items])

  const handleScroll = () => {
    if (carouselRef.current) {
      const atStart = carouselRef.current.scrollLeft === 0
      const atEnd =
        carouselRef.current.scrollLeft >=
        carouselRef.current.scrollWidth - carouselRef.current.offsetWidth

      const allVisible = carouselRef.current.scrollWidth <= carouselRef.current.offsetWidth

      setIsAtStart(atStart)
      setIsAtEnd(atEnd)
      setAllItemsVisible(allVisible)
    }
  }

  useEffect(() => {
    const ref = carouselRef.current

    if (ref) {
      ref.addEventListener("scroll", handleScroll)
      arrowVisibility()
    }

    return () => {
      if (ref) {
        ref.removeEventListener("scroll", handleScroll)
      }
    }
  }, [arrowVisibility])

  const moveForward = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" })
    }
  }

  const moveBackward = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" })
    }
  }

  return (
    <ProductShoppableGrid ref={elRef}>
      <Carousel>
        <Headline>You may also be interested in</Headline>
        <Scroll />
        <ScrollableGrid ref={carouselRef}>
          <ArrowLeft disabled={isAtStart || allItemsVisible} onClick={moveBackward} />
          <ArrowRight
            disabled={isAtEnd || allItemsVisible || !showArrowRight}
            onClick={moveForward}
            hidden={!showArrowRight}
          />
          {items.map((item, index) => (
            <Fragment key={index}>
              <DesktopWrapper>
                <Card item={item} />
              </DesktopWrapper>
              <MobileWrapper>
                <Card item={item} />
              </MobileWrapper>
            </Fragment>
          ))}
        </ScrollableGrid>
      </Carousel>
    </ProductShoppableGrid>
  )
}

export default MultiProductShoppable
